import { render, staticRenderFns } from "./WrongAccountDialog.vue?vue&type=template&id=45554b93"
import script from "./WrongAccountDialog.vue?vue&type=script&lang=ts"
export * from "./WrongAccountDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports